import $ from 'jquery';
import * as tips from './tips';
import * as api from './api';
import { initPage } from './base';
import { sendSuccData } from './dataReport';
export const checkReserveStatus = () =>
  localStorage.getItem(api.PHONEMERGE) && localStorage.getItem(api.TOKEN);

const phoneFormate = {
  886: /^\d{10}$/,
  852: /^\d{8}$/,
  853: /^\d{8}$/,
  65: /^\d{8}$/,
  60: /(^01\d{8,9}$)|(^1\d{8,10}$)/,
};
const submitForm = {
  phone_code: 886,
  phone: 0,
  device: 'android',
  cid: window.cid,
  scid: window.scid,
};

$('.j-check-term').on('click', ({ target }) => {
  $(target).toggleClass('checked');
});
// android or ios
$('.j-device-check').on('click', ({ target }) => {
  $('.j-device-check').removeClass('active');
  $(target).addClass('active');
  submitForm.device = $(target).attr('data-device');
});
$('.j-area-choose').on('change', () => {
  submitForm.phone_code = $('.j-area-choose').val();
});
$('.j-confirm-btn').on('click', async () => {
  const phone = $('.j-telephone-input').val().trim();
  if (!phone.length) {
    tips.showReserveTips('請先輸入電話號碼');
    return;
  }
  if (!$('.j-check-term').hasClass('checked')) {
    tips.showReserveTips('請先勾選服務條款');
    return;
  }
  // 號碼格式校驗
  if (!phoneFormate[submitForm.phone_code].test(phone)) {
    tips.showReserveTips('電話號碼格式錯誤');
    return;
  }
  submitForm.phone = phone;
  tips.showReserveTips('');
  let reserveRes = await api.reserve(submitForm);
  if (+reserveRes.code === 1) {
    sendSuccData();
    localStorage.setItem(api.TELEPHONE, phone);
    api.updateReserveData(reserveRes.data.phoneMerge, reserveRes.data.token); // 刷新token
    reserveRes.data.isRepeat
      ? $('.j-finished-popup').fadeIn(500)
      : $('.j-reserve-success-popup').fadeIn(500);
    await initPage();
  } else {
    tips.alert('', reserveRes.msg);
  }
});
